import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background-50">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-6">
          <i className="ri-emotion-sad-line text-5xl text-foreground-400"></i>
        </div>
        <h1 className="text-6xl font-bold text-foreground-200 mb-4">404</h1>
        <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
        <p className="text-sm text-foreground-500 mb-8">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-block px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}